import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Login } from "./pages/Login";

function App() {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Preserve ?redirect_uri=... when someone lands on / */}
      <Route
        path="*"
        element={<Navigate to={`/login${location.search}`} replace />}
      />
    </Routes>
  );
}

export default App;
